import React from "react";
import { getIn, useFormikContext } from "formik";
import { useLandingPageContext } from "pages/Context/LandinPageContext";
import LSelect from "components/Inputs/LSelect";
import { Col, Row } from "react-bootstrap";
import { IOptionsSelect } from "components/Inputs/interfaces/options.interface";
import PixPayment from "./PixPayment";

export default function FormPix() {
  const { installmentsContext, supplierDataContext, pixCopyAndPasteContext} = useLandingPageContext();
  const { values, errors, setFieldValue, touched, setFieldTouched } = useFormikContext();

  const options: IOptionsSelect[] = [
    {
      label: `${supplierDataContext?.cnpj}`,
      value: 0
    },
    {
      label: `${supplierDataContext?.cpf ?? ""}`,
      value: 1
    }
  ];
    
  return (
    <div className="flex-grow-1 d-flex">     
      {!pixCopyAndPasteContext && <div>
        <Row>
          <Col md={6} sm={12}>
            <LSelect
              label="CPF/CNPJ"
              options={options}
              placeholder="CPF/CNPJ"
              name="identification"
              required
              value={getIn(values, "identification")}
              onChange={(e) => setFieldValue("identification", Number(e.target.value))}
              onBlur={() => setFieldTouched("identification", true)}
              error={getIn(errors, "identification")}
              className="mb-1"
            />
          </Col>
          <Col md={6} sm={12}>
            <LSelect
              options={installmentsContext}
              label="Parcelamento"
              name="installmentsNumber"
              value={getIn(values, "installmentsNumber")}
              onChange={(e) => {
                setFieldValue("installmentsNumber",e.target.value ? Number(e.target.value) : "");
              }}
              onBlur={() => setFieldTouched("installmentsNumber", true)}
              required
              isInvalid={!!getIn(touched, "installmentsNumber") && !!getIn(errors, "installmentsNumber")}
              error={getIn(errors, "installmentsNumber")}
            />
          </Col>
        </Row>
        <div className="d-flex flex-column gap-3 py-3" style={{ fontSize: ".875rem"}}>
          <span className="text-left">      
            O pagamento via <strong>PIX Recorrente</strong> garante o acesso contínuo ao sistema. 
            Todo mês, um novo pagamento deverá ser realizado para manter sua assinatura ativa.
          </span>
          <span className="text-left">      
            Assim que o pagamento for confirmado, seu acesso será atualizado automaticamente. 
            O prazo de confirmação pode variar conforme a instituição bancária, mas geralmente ocorre em <strong>poucos minutos</strong>.
          </span>
        </div>
      </div>}
      <div className="flex-grow-1 d-flex">
        {pixCopyAndPasteContext && <PixPayment pix={pixCopyAndPasteContext}/>}
      </div>

    </div>
  );
}